import { type ConfigObject } from '../../../../_configs/types';
import type { Car, CarList } from '../../../../_types/Car';
import type { Modules } from '../../../../modules/_definition/types';
import checkUndefinedNullOrEmpty from '../../../../utils/tools/checkUndefinedNullOrEmpty';
import type { FaarenListCar } from '../../../types/faaren';
import handleCar from './handleCar';

export default async function handleCarList(list: CarList['searchResult'], module: Modules, settings: ConfigObject, faarenVehicles: FaarenListCar[]): Promise<Record<string, Car<false>>> {
    const newList: Record<string, Car<false>> = {};
    const oldList = list?.cars || [];

    if (!checkUndefinedNullOrEmpty(oldList)) {
        for (let i = 0; i < oldList?.length; i++) {
            const car = oldList?.[i];
            newList['car_' + car?.id] = await handleCar(
                {
                    ...car,
                    bilder: {
                        ...car?.bilder,
                        bilder: car?.bilder?.anzahl,
                    },
                    engine: {
                        ...car?.engine,
                        envkv: car?.envkv,
                        verbrauch_0: [car?.engine?.verbrauch?.[0], null, null, car?.engine?.verbrauch?.[1]],
                    },
                    leasing: {
                        ...car?.leasing,
                        anzahlung: parseFloat(car?.leasing?.anzahlung),
                    },
                    leasingComm: {
                        ...car?.leasingComm,
                        anzahlung: parseFloat(car?.leasingComm?.anzahlung),
                    },
                    preis: {
                        mwst: car?.mwst > 0 ? 1 : 0,
                        mwst_satz: car?.mwst,
                        transport: car?.transport,
                        upe: car?.upe,
                        vk: car?.preis as number,
                        vkn: car?.vkn,
                    },
                },
                module,
                settings,
                faarenVehicles,
                false
            );
        }
    }

    return newList;
}
